<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12 md12 px-1 py-3>
                <ContentLoader :width="1149" :height="500" v-if="$vuetify.breakpoint.mdAndUp">
                    <rect x="0" y="0" rx="1" ry="1" width="556" height="100" />

                    <rect x="580" y="0" rx="1" ry="1" width="300" height="30" />
                    <rect x="580" y="50" rx="1" ry="1" width="100" height="20" />

                    <rect x="580" y="100" rx="1" ry="1" width="560" height="20" />
                    <rect x="580" y="125" rx="1" ry="1" width="560" height="20" />
                    <rect x="580" y="150" rx="1" ry="1" width="560" height="20" />
                    <rect x="580" y="175" rx="1" ry="1" width="560" height="20" />

                    <rect x="1050" y="310" rx="1" ry="1" width="90" height="30" />
                    <rect x="1050" y="360" rx="1" ry="1" width="90" height="20" />

                    <rect x="730" y="420" rx="1" ry="1" width="100" height="30" />
                    <rect x="880" y="415" rx="1" ry="1" width="260" height="40" />
                </ContentLoader>

                <ContentLoader v-else :width="556" :height="520">
                    <rect x="0" y="0" rx="1" ry="1" width="556" height="300" />

                    <rect x="0" y="315" rx="1" ry="1" width="300" height="20" />
                    <rect x="0" y="345" rx="1" ry="1" width="100" height="10" />

                    <rect x="0" y="370" rx="1" ry="1" width="560" height="10" />
                    <rect x="0" y="385" rx="1" ry="1" width="560" height="10" />
                    <rect x="0" y="400" rx="1" ry="1" width="560" height="10" />

                    <rect x="466" y="420" rx="1" ry="1" width="90" height="30" />
                    <rect x="466" y="460" rx="1" ry="1" width="90" height="20" />

                    <rect x="186" y="495" rx="1" ry="1" width="100" height="20" />
                    <rect x="306" y="490" rx="1" ry="1" width="260" height="30" />
                </ContentLoader>
            </v-flex>
            <v-flex xs12>
                <v-tabs slider-color="primary">
                    <v-tab ripple>
                        {{ "Product description"| translation }}
                    </v-tab>
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <ContentLoader :width="1105" :height="200">
                                    <rect x="0" y="0" rx="1" ry="1" width="1105" height="20" />
                                    <rect x="0" y="25" rx="1" ry="1" width="1105" height="20" />
                                    <rect x="0" y="50" rx="1" ry="1" width="1105" height="20" />
                                    <rect x="0" y="75" rx="1" ry="1" width="1105" height="20" />
                                </ContentLoader>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import { ContentLoader } from 'vue-content-loader';

    export default {
        name: 'ProductPlaceholderTemplate',
        components: {
            ContentLoader,
        },
    };
</script>